export const CREATE_EXPENSE_ACCOUNT_MODAL_ID =
  'create-expense-account-modal-content';

export const RESOLVE_CONFLICT_MANUALLY_ID = 'resolve-conflict-manually-popover';
